import { getRandomNumber } from 'src/shared/utils/get-random-number';

export type TFormMessageType = 'error' | 'info';

export class FormMessage {
  readonly entityId: string | number;
  readonly text: string;
  readonly type: TFormMessageType;

  constructor(text: string, type: TFormMessageType, key?: string | number) {
    this.entityId = key ?? getRandomNumber();
    this.text = text;
    this.type = type;
  }
}
